__turbopack_context__.v({
  "accordionSlideOverwrite": "baselineSummit-module-scss-module__UZfjjW__accordionSlideOverwrite",
  "content": "baselineSummit-module-scss-module__UZfjjW__content",
  "eventDateRow": "baselineSummit-module-scss-module__UZfjjW__eventDateRow",
  "eventDescription": "baselineSummit-module-scss-module__UZfjjW__eventDescription",
  "eventDetails": "baselineSummit-module-scss-module__UZfjjW__eventDetails",
  "eventDetailsContent": "baselineSummit-module-scss-module__UZfjjW__eventDetailsContent",
  "eventDetailsTitle": "baselineSummit-module-scss-module__UZfjjW__eventDetailsTitle",
  "eventInformation": "baselineSummit-module-scss-module__UZfjjW__eventInformation",
  "eventMeta": "baselineSummit-module-scss-module__UZfjjW__eventMeta",
  "eventMetaItem": "baselineSummit-module-scss-module__UZfjjW__eventMetaItem",
  "eventMetaLabel": "baselineSummit-module-scss-module__UZfjjW__eventMetaLabel",
  "fadeIn": "baselineSummit-module-scss-module__UZfjjW__fadeIn",
  "fadeOut": "baselineSummit-module-scss-module__UZfjjW__fadeOut",
  "faq": "baselineSummit-module-scss-module__UZfjjW__faq",
  "faqTitle": "baselineSummit-module-scss-module__UZfjjW__faqTitle",
  "feature": "baselineSummit-module-scss-module__UZfjjW__feature",
  "featureDescription": "baselineSummit-module-scss-module__UZfjjW__featureDescription",
  "featureGrid": "baselineSummit-module-scss-module__UZfjjW__featureGrid",
  "featureNumber": "baselineSummit-module-scss-module__UZfjjW__featureNumber",
  "featureTitle": "baselineSummit-module-scss-module__UZfjjW__featureTitle",
  "hero": "baselineSummit-module-scss-module__UZfjjW__hero",
  "heroBackground": "baselineSummit-module-scss-module__UZfjjW__heroBackground",
  "heroBackgroundImage": "baselineSummit-module-scss-module__UZfjjW__heroBackgroundImage",
  "heroContent": "baselineSummit-module-scss-module__UZfjjW__heroContent",
  "heroEyebrow": "baselineSummit-module-scss-module__UZfjjW__heroEyebrow",
  "heroLocation": "baselineSummit-module-scss-module__UZfjjW__heroLocation",
  "heroTitle": "baselineSummit-module-scss-module__UZfjjW__heroTitle",
  "overview": "baselineSummit-module-scss-module__UZfjjW__overview",
  "overviewDescription": "baselineSummit-module-scss-module__UZfjjW__overviewDescription",
  "overviewIntroduction": "baselineSummit-module-scss-module__UZfjjW__overviewIntroduction",
  "overviewTitle": "baselineSummit-module-scss-module__UZfjjW__overviewTitle",
  "page": "baselineSummit-module-scss-module__UZfjjW__page",
  "registerButton": "baselineSummit-module-scss-module__UZfjjW__registerButton",
  "scaleIn": "baselineSummit-module-scss-module__UZfjjW__scaleIn",
  "scaleOut": "baselineSummit-module-scss-module__UZfjjW__scaleOut",
  "venueImage": "baselineSummit-module-scss-module__UZfjjW__venueImage",
  "venueImageWrap": "baselineSummit-module-scss-module__UZfjjW__venueImageWrap",
  "zoomIn": "baselineSummit-module-scss-module__UZfjjW__zoomIn",
  "zoomOut": "baselineSummit-module-scss-module__UZfjjW__zoomOut",
});
